import { AnalyticsService } from '@kfc-global/react-shared/analytics';
import events from '@kfc-global/react-shared/analytics/Register';
import { formatPhoneNumber, getDataLayer } from 'common/utilities/utils';

export const addFavouriteItemToCart = async itemsObj => {
  await AnalyticsService.registerEvent(
    events.add_to_cart.name,
    {
      data: {
        event: 'add_to_cart',
        ecommerce: {
          // add_to_cart: {
          items: [itemsObj],
          // },
        },
      },
    },
    getDataLayer,
  );
};
/**
 * Method to set analytics items in the data layer object
 */
export const editPersonalInformationAnalytics = customerInfo => {
  AnalyticsService.registerEvent(
    'editPersonalInformation',
    {
      '%event%': 'editPersonalInformation',
      '%firstName%': customerInfo.firstName || 'NA',
      '%lastName%': customerInfo.lastName || 'NA',
      '%email%': customerInfo.email || 'NA',
      '%phone%': customerInfo.phone || 'NA',
      '%dateOfBirth%': customerInfo.dateOfBirth || 'NA',
      '%postCode%': customerInfo.postalCode || 'NA',
    },
    getDataLayer,
  );
};

export const updateCommunicationPreferencesAnalytics = selectedPreferences => {
  AnalyticsService.registerEvent(
    'updateCommunicationPreferences',
    {
      '%event%': 'updateCommunicationPreferences',
      '%marketingEmails%': selectedPreferences.find(item => item === 'marketing-emails') ? 'true' : 'false',
      '%editorAndCustomerFavourites%': selectedPreferences.find(item => item === 'editor-pick') ? 'true' : 'false',
      '%newsAndAnnouncements%': selectedPreferences.find(item => item === 'kfc-news') ? 'true' : 'false',
      '%doNotSellInformation%': selectedPreferences.find(item => item === 'do-not-sell') ? 'true' : 'false',
    },
    getDataLayer,
  );
};

export const deleteAccountAnalytics = async userId => {
  await AnalyticsService.registerEvent(
    'deleteAccount',
    {
      '%event%': 'deleteAccount',
      '%userID%': userId || 'NA',
    },
    getDataLayer,
  );
};

export const signoutAnalytics = async userId => {
  await AnalyticsService.registerEvent(
    'signOutSuccess',
    {
      '%event%': 'signOutSuccess',
      '%userID%': userId || 'NA',
    },
    getDataLayer,
  );
};
